export class ActivityLogSearchCriteria {
  public  tableName : string;
  public  table_name : string;
  public  description : string;
  public  userName : string;
  public  actionType : string;
  public  startDate : string;
  public  endDate : string;

  public  pageSize : number;
  public  pageNumber : number;
  public  sortingKey : string;
  public  sortingValue : string;

  constructor() {}
}
